export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 25, 50];
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_SIZE_LABEL = 'registros por página'
export const DEFAULT_PAGE_SIZE_LABEL_OPTIONS = 'registros por página'
export const DEFAULT_PAGE = 1;
